<template>
  <div class="form-actions col-md-12 p-0 m-0 d-flex justify-content-between align-items-center">
    <div class="col-md-5 d-flex align-items-center">
      <template>
        <v-btn 
          v-if="showSave"
          :style="'color:'+subColor+'!important; background-color:'+color+'!important'"
          class="mr-5"
          :class="{off:disabled}"
          @click="$emit('save')"
        >
          {{actionText}}
        </v-btn>
        <slot v-if="extraAction" :name="extraActionId"></slot>
        <router-link 
          class="backtrack" 
          :to="{name:pathBack}"
        >
          <i class="mdi mdi-arrow-left"></i>
          Voltar
        </router-link>
      </template>
    </div>
    
    <div class="col-md-5">
      <template>
        <slot></slot>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name:"TheActions",
  props:{
    color:String,
    subColor:String,
    actionText:String,
    pathBack:String,
    disabled:Boolean,
    showSave:Boolean,
    extraAction:Boolean,
    extraActionId:String
  }
}
</script>

<style scoped>
  /* rodapé dos formulários: ação principal + Voltar como botão de contorno */
  .form-actions {
    margin-top: 18px !important;
    padding-top: 18px !important;
    border-top: 1px solid var(--line);
  }
  .backtrack {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    height: 36px;
    padding: 0 16px;
    border: 1px solid var(--line);
    border-radius: 8px;
    background: white;
    color: var(--ink) !important;
    font-size: .9rem;
    font-weight: 600;
    text-decoration: none;
    transition: background-color .15s ease, border-color .15s ease;
  }
  @media (max-width: 767px) {
    .form-actions {
      flex-wrap: wrap;
      gap: 10px;
    }
    .form-actions > div {
      width: auto !important;
      flex: 1 1 auto !important;
      max-width: 100% !important;
      flex-wrap: wrap;
      gap: 8px;
      padding: 0 !important;
    }
  }
  .backtrack:hover {
    background: #f6f7fa;
    border-color: #d5d9e2;
  }
  .off {
    opacity: 0.7;
    pointer-events: none;
  }
</style>